import { queryKeyFn } from '../../generated/sitContext';
export const timesheetsQueryKey = queryKeyFn({
    path: '/timesheets',
    operationId: 'getApiTimesheets',
    variables: {},
});
export const timesheetsPredicate = (query) => {
    return (query.queryKey.length === 1 ||
        (query.queryKey.length === 2 && typeof query.queryKey[1] === 'object'));
};
export function setTimesheetsQueryData(queryClient, updater) {
    // Optimistically update to the new value
    return queryClient.setQueriesData({
        queryKey: timesheetsQueryKey,
        predicate: timesheetsPredicate,
    }, updater);
}
export function getTimesheetFromTimesheetsQueryData(queryClient, id) {
    const queryDatas = queryClient.getQueriesData({
        queryKey: timesheetsQueryKey,
        predicate: timesheetsPredicate,
    });
    for (const queryData of queryDatas) {
        const [, timesheets] = queryData;
        if (!timesheets)
            continue;
        const timesheet = timesheets.find((timesheet) => timesheet.id === id);
        if (timesheet)
            return timesheet;
    }
}
export const invalidateTimesheetsQuery = (queryClient) => queryClient.invalidateQueries({
    queryKey: timesheetsQueryKey,
    predicate: timesheetsPredicate,
});
//# sourceMappingURL=query.js.map